import "./VolanteAdmin.css";

import { addDays, differenceInDays, format, parse } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import { Sidebar } from "primereact/sidebar";
import { useContext, useEffect, useState } from "react";
import DatePicker from "react-date-picker";

import { Authorization } from "../../common/AuthorizationCpt";
import IconServiceMore from "../../images/icon_service_more.svg";
import { dateToRegularFormat } from "../../utils/dates";
import { formatMoney, formatNumber } from "../../utils/numbers";
import AdditionalInfoReviewingModal from "../AdditionalVolanteModal/AdditionalInfoReviewingModal";
import AdditionalServiceStatusModal from "../AdditionalVolanteModal/AdditionalServiceStatusModal";

import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";

import VolanteDetailCpt from "../VolanteDetail/VolanteDetail";
import VolanteDetails from "../VolanteDetails/VolanteDetails";
import { DetailsContainer } from "../VolanteDetails/VolanteDetailsStyles";

import {
  DivDate,
  DivDropdown,
  FlightInfo,
  MainButton,
  OptionTemplateVolante,
  StatusBar,
  StatusDiv,
  StatusSection,
  VolanteDescription,
  VolanteDetail,
  VolanteHeader,
} from "./VolanteAdminStyles";
import { VolanteAdditionalServicesAdmin } from "./VolanteAdditionalServicesAdmin";
import { AdditionalRucsModalAdmin } from "../AdditionalVolanteModalAdmin/AdditionalRucsModalAdmin";
import { AdminStatusSectionDetails } from "./AdminStatusSectionDetails";

const detaultAmount = {
  sellingValue: { pen: 0, usd: 0 },
  discount: { pen: 0, usd: 0 },
  netValue: { pen: 0, usd: 0 },
  igv: { pen: 0, usd: 0 },
  sellingPrice: { pen: 0, usd: 0 },
  amount: 0,
};

export const extractDataQuotationEstimate = (response) => {
  const quotation_details = response.quotation_details.map((detail, index) => {
    return {
      id: index,
      description: detail.description,
      sellingValue: detail.sales_value,
      discount: detail.discount,
      netValue: detail.net_value,
      igv: detail.sales_tax,
      sellingPrice: detail.sales_price,
      category: detail.category,
      amount: detail.amount,
      sap_code: detail.sap_code,
    };
  });

  const total = {
    id: "totalId",
    description: "Total",
    sellingValue: response.sales_value_total,
    discount: response.discount_total,
    netValue: response.net_value_total,
    igv: response.sales_tax_total,
    sellingPrice: response.sales_price_total,
    amount: response.amount_total,
  };

  return { quotation_details, total };
};

export const VolanteAdmin = (props) => {
  const {
    damStatus,
    dni,
    loadDateWithdrawal,
    volante,
    enableCheckbox,
    dateRucHook,
    disabled,
    onChangeVolantesForInvoice,
    refreshBilling,
  } = props;
  const {
    id,
    importer,
    weight,
    parcels,
    rucs,
    airline,
    flightDate,
    masterAirWaybill,
    houseAirWaybill,
    thirdPartyStatus,
    paymentStatus,
    billableRuc,
    withdrawalDate,
    salesPriceTotal,
    entryDate,
    contentDescription,
  } = volante;
  const [restrictions, setRestrictions] = useState(0);
  useEffect(() => {
    const restrictions =
      damStatus.problems.length + volante.status2.problems.length;
    setRestrictions(restrictions);
  }, [damStatus, volante.status2]);
  const [pricing, setPricing] = useState(volante.pricing);

  const [amount, updateAmount] = useState(
    paymentStatus !== "unquoted" ? salesPriceTotal : "(No cotizado)"
  );
  const [quotationProcessStatus, setQuotationProcessStatus] =
    useState<any>(null);
  const [selectedRuc, updateSelectedRuc] = useState(
    ["reviewing", "approved"].includes(thirdPartyStatus.option) ? "other" : "0"
  );
  const [showDetail, updateShowDetail] = useState(true);
  const [showRucModal, updateShowRucModal] = useState(false);
  const [showServiceStatusModal, updateShowServiceStatusModal] =
    useState(false);
  // eslint-disable-next-line
  const [rucOptions, _] = useState(rucs);
  const [useDollars] = useContext(CurrencyContext);
  const [uploadDate, updateUploadDate] = useState<any>();
  useEffect(() => {
    dateRucHook[1]((oldDateRuc) => {
      const newDateRucStatus = { ...oldDateRuc };
      newDateRucStatus[id] = {
        amount: amount,
        billableRuc: selectedRuc,
        withdrawalDate1: uploadDate,
      };
      return newDateRucStatus;
    });
    // eslint-disable-next-line
  }, [selectedRuc, amount, id, uploadDate]);

  const toggleRucModal = (showFileModal) => {
    updateShowRucModal(!showRucModal);
  };

  const closeModalRuc = () => {
    updateShowRucModal(false);
    setSelectedCountry(null);
  };
  const [quotation] = useState({});
  const [quotationDetails, setQuotationDetails] = useState([]);

  const [, setOriginalQuotationDetailsTotal] = useState(detaultAmount);

  const [daysStored, setDaysStored] = useState(volante.days_stored);
  const [quotationDetailsTotal, setQuotationDetailsTotal] =
    useState(detaultAmount);

  const toggleDetail = () => {
    restrictions === 0 && updateShowDetail(!showDetail);
  };

  const [volanteServiceSidebar, setVolanteServiceSidebar] = useState(false);

  const toggleVolanteServiceSidebar = (e) => {
    setVolanteServiceSidebar(!volanteServiceSidebar);
    e?.stopPropagation();
  };

  const toggleServices = (e) => {
    if (isReviewing) {
      updateShowServiceStatusModal(true);
      e?.stopPropagation();
    } else {
      toggleVolanteServiceSidebar(e);
    }
  };

  const [additionalServices, setAdditionalServices] = useState([]);

  useEffect(() => {
    volante.additional_services = additionalServices;
  }, [volante, additionalServices]);

  const uploadDateOnChange = (newDate) => {
    updateUploadDate(newDate);
    const dateToday = new Date();
    const resultDifferenceDay = differenceInDays(newDate, dateToday);
    const formatDateToday = format(dateToday, "yyyy-MM-dd");
    const formatNewDate = format(newDate, "yyyy-MM-dd");
    if (formatDateToday === formatNewDate) {
      setDaysStored(volante.days + resultDifferenceDay);
    } else {
      setDaysStored(volante.days + (resultDifferenceDay + 1));
    }
  };

  const [deletedItemsByDate, setDeletedItemsByDate] = useState({});

  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  useEffect(() => {
    const { quotation_estimate_list, limit_days_for_withdrawal_date } = pricing;
    const lowestDate = quotation_estimate_list
      .map((quotation) => {
        return parse(quotation.withdrawal_date, "yyyy-MM-dd", new Date());
      })
      .reduce((t, e) => {
        return t.getTime() < e.getTime() ? t : e;
      }, new Date(100000000000000));

    setMinDate(lowestDate);
    updateUploadDate((uploadDate) => {
      return uploadDate ? uploadDate : lowestDate;
    });

    setMaxDate(addDays(lowestDate, limit_days_for_withdrawal_date - 1));
  }, [pricing, volante]);

  useEffect(() => {
    if (!uploadDate) return;

    const { quotation_estimate_list } = pricing;
    const index = format(uploadDate, "yyyy-MM-dd");
    const response = quotation_estimate_list.find(
      (q) => q.withdrawal_date === index
    );
    const deletedAdditionalServices = deletedItemsByDate[index] || [];
    setIsReviewing(
      volante.third_party_billing_authorization_status.option === "reviewing"
    );
    const { quotation_details, total } = extractDataQuotationEstimate(response);
    const filtered_quotation_details = quotation_details.filter((detail) => {
      return !deletedAdditionalServices.includes(detail.sap_code);
    });
    setAdditionalServices(
      filtered_quotation_details
        .filter((i) => i.category === "additional_service")
        .map((i) => ({ sap_code: i.sap_code, amount: i.amount }))
    );
    setQuotationDetails(filtered_quotation_details);
    setOriginalQuotationDetailsTotal(total);

    if (deletedAdditionalServices.length > 0) {
      const result = filtered_quotation_details.reduce(
        (cumulative, element) => {
          return {
            amount: cumulative.amount + element.amount,
            sellingValue: {
              usd: cumulative.sellingValue.usd + element.sellingValue.usd,
              pen: cumulative.sellingValue.pen + element.sellingValue.pen,
            },
            discount: {
              usd: cumulative.discount.usd + element.discount.usd,
              pen: cumulative.discount.pen + element.discount.pen,
            },
            netValue: {
              usd: cumulative.netValue.usd + element.netValue.usd,
              pen: cumulative.netValue.pen + element.netValue.pen,
            },
            igv: {
              usd: cumulative.igv.usd + element.igv.usd,
              pen: cumulative.igv.pen + element.igv.pen,
            },
            sellingPrice: {
              usd: cumulative.sellingPrice.usd + element.sellingPrice.usd,
              pen: cumulative.sellingPrice.pen + element.sellingPrice.pen,
            },
          };
        },
        detaultAmount
      );
      setQuotationDetailsTotal(result);
      updateAmount(result.sellingPrice);
    } else {
      setQuotationDetailsTotal(total);
      updateAmount(response.sales_price_total);
      setQuotationProcessStatus(response.quotation_process_status);
    }
  }, [
    pricing,
    uploadDate,
    deletedItemsByDate,
    volante.third_party_billing_authorization_status.option,
  ]);

  useEffect(() => {
    volante.withdrawal_date = new Date(uploadDate);
  }, [volante, uploadDate]);

  const [isReviewing, setIsReviewing] = useState(
    thirdPartyStatus.option === "reviewing"
  );

  const [
    showConfirmationModalVolanteDocument,
    setShowConfirmationModalVolanteDocument,
  ] = useState(false);

  const [showModalErrorAdditionalRucs, setShowModalErrorAdditionalRucs] =
    useState(false);
  const [showModalMessageAdditionalRucs, setShowModalMessageAdditionalRucs] =
    useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);

  const onCountryChange = (e) => {
    setSelectedCountry(e.value);

    if (e.value.option === "other" && thirdPartyStatus.option !== "approved") {
      updateSelectedRuc("0");
      updateShowRucModal(true);
      onChangeVolantesForInvoice();
      return;
    }

    updateSelectedRuc(e.value.option);
    onChangeVolantesForInvoice();
  };

  const countryOptionTemplate = (option) => {
    const optionOthers = option.option === "other" ? "" : " - ";
    return (
      <div style={{ cursor: "pointer" }}>
        <OptionTemplateVolante
          color="#08082B"
          fontWeight={600}
          marginBottom="0.2rem"
        >
          {option.ruc} {optionOthers}
          {option.name} {optionOthers} {option?.label}
        </OptionTemplateVolante>
        <OptionTemplateVolante color="#30345C" fontWeight={400}>
          <label>{option?.address}</label>
        </OptionTemplateVolante>
      </div>
    );
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <div
            style={{
              fontSize: "1.4rem",
              fontWeight: 600,
              fontFamily: "Montserrat",
            }}
          >
            {option.name}
          </div>
        </div>
      );
    }
    return (
      <span style={{ fontSize: "1.4rem", fontFamily: "Montserrat" }}>
        {props.placeholder}
      </span>
    );
  };

  useEffect(() => {
    if (
      selectedRuc === "other" &&
      ["reviewing", "approved"].includes(thirdPartyStatus.option)
    ) {
      const findOtherLabel = rucOptions.find((resp) => resp.option === "other");
      setSelectedCountry(findOtherLabel);
    }
    // eslint-disable-next-line
  }, [selectedRuc]);
  return (
    <div>
      {showModalErrorAdditionalRucs && showModalMessageAdditionalRucs && (
        <ConfirmationModal
          title={"Atención"}
          message={showModalMessageAdditionalRucs}
          toggleModal={() => {
            setShowModalErrorAdditionalRucs(false);
            setShowModalMessageAdditionalRucs("");
          }}
          onAccept={() => {
            setShowModalErrorAdditionalRucs(false);
            setShowModalMessageAdditionalRucs("");
          }}
        />
      )}
      {showConfirmationModalVolanteDocument && (
        <ConfirmationModal
          title={"Documentos subidos con éxito"}
          message={
            "La carga de los documentos ha sido exitosa. Haga clic en entendido o cierre el diálogo para continuar."
          }
          toggleModal={() => {
            setShowConfirmationModalVolanteDocument(false);
            refreshBilling();
          }}
          onAccept={() => {
            setShowConfirmationModalVolanteDocument(false);
            refreshBilling();
          }}
        />
      )}

      <VolanteHeader
        amountReady={amount !== "(No cotizado)"}
        enableCheckbox={enableCheckbox}
      >
        <div className="main-info-header">
          <p>{importer}</p>
          <p className="id">{id}</p>
          <p className="entry-date">{`Ingresó el ${dateToRegularFormat(
            entryDate
          )}`}</p>
        </div>
        <div>
          <AdminStatusSectionDetails
            invoice={{
              ...volante,
              status: volante.status2,
              quotationNum: volante.id,
            }}
          />
        </div>
        <div>
          <StatusSection>
            <StatusBar>
              <StatusDiv className="status" status={paymentStatus.category}>
                <span>{paymentStatus.label.toUpperCase()}</span>
              </StatusDiv>
            </StatusBar>
          </StatusSection>
        </div>
        <div>{formatNumber(weight)}</div>
        <div>{parcels}</div>
        <div>{daysStored}</div>
        <div>
          {volante.payment_status.option !== "unquoted" && (
            <>
              <p>{dateToRegularFormat(withdrawalDate)}</p>
            </>
          )}
          {volante.payment_status.option === "unquoted" && (
            <>
              {restrictions > 0 ? (
                <p>{dateToRegularFormat(new Date())}</p>
              ) : (
                <DivDate>
                  <DatePicker
                    className="clickable-element"
                    value={uploadDate}
                    onChange={uploadDateOnChange}
                    clearIcon={null}
                    dayPlaceholder={"dd"}
                    locale={"es-PE"}
                    monthPlaceholder={"mm"}
                    showLeadingZeros={true}
                    yearPlaceholder={"yy"}
                    maxDate={maxDate}
                    minDate={minDate}
                  />
                </DivDate>
              )}
            </>
          )}
        </div>
        <div>
          <Authorization
            actions={[
              "dam.get_dam_estimate",
              "volante.update_volante_quotation_estimate",
            ]}
          >
            {paymentStatus.option !== "unquoted" && restrictions === 0 ? (
              <p>{billableRuc.name}</p>
            ) : (
              <>
                <DivDropdown className="hollall">
                  <Dropdown
                    className="volante-dropdown-select-style"
                    panelClassName="panelVolanteDropdown"
                    value={selectedCountry}
                    disabled={
                      disabled ||
                      ["reviewing", "approved"].includes(
                        thirdPartyStatus.option
                      )
                    }
                    options={rucOptions}
                    onChange={onCountryChange}
                    optionLabel="name"
                    placeholder="(Ninguno)"
                    valueTemplate={selectedCountryTemplate}
                    itemTemplate={countryOptionTemplate}
                    style={{ width: "10rem" }}
                  />
                </DivDropdown>
              </>
            )}
          </Authorization>
        </div>
        <div className="amount">
          {restrictions > 0 ? (
            <> {"(No cotizado)"}</>
          ) : quotationProcessStatus?.option !== "processed" &&
            volante.payment_status.option === "quoted" ? (
            <> {"(No procesado)"}</>
          ) : (
            <>{formatMoney(amount, useDollars)}</>
          )}
        </div>
      </VolanteHeader>
      <VolanteDescription>
        <p>
          {contentDescription
            ? contentDescription
            : "Este volante no tiene ninguna descripción."}
        </p>
      </VolanteDescription>

      <VolanteDetail>
        <FlightInfo onClick={toggleDetail}>
          <div>
            <h2>Línea aérea</h2>
            <p>{airline}</p>
          </div>
          <div>
            <h2>Fecha de vuelo</h2>
            <p>{dateToRegularFormat(flightDate)}</p>
          </div>
          <div>
            <h2>Guía madre</h2>
            <p>{masterAirWaybill}</p>
          </div>
          <div>
            <h2>Guía hija</h2>
            <p>{houseAirWaybill}</p>
          </div>
          <Authorization actions={["quotation-detail.get_additional_services"]}>
            {volante.payment_status.option === "unquoted" && (
              <>
                {restrictions === 0 && (
                  <>
                    {!["reviewing", "aproved"].includes(
                      volante.third_party_billing_authorization_status.option
                    ) && (
                      <div>
                        <MainButton onClick={toggleServices}>
                          <img src={IconServiceMore} alt="" /> Servicio
                        </MainButton>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </Authorization>
        </FlightInfo>
        {showServiceStatusModal ? (
          <AdditionalServiceStatusModal
            toggleModal={() => updateShowServiceStatusModal(false)}
          />
        ) : null}
        <Authorization actions={["volante.update_volante_quotation_estimate"]}>
          {restrictions === 0 && showDetail && (
            <div>
              <DetailsContainer>
                <VolanteDetails
                  volante={volante}
                  quotationDetails={quotationDetails}
                  disableServices={false}
                  onRemoveClick={(detail) => {
                    setDeletedItemsByDate((deletedItemsByDate) => {
                      const key = format(uploadDate, "yyyy-MM-dd");
                      const deletedAdditionalServices =
                        deletedItemsByDate[key] || [];
                      return {
                        ...deletedItemsByDate,
                        [key]: [...deletedAdditionalServices, detail.sap_code],
                      };
                    });
                  }}
                />
                <VolanteDetailCpt
                  detail={quotationDetailsTotal}
                  isTotal={true}
                  volante={volante}
                ></VolanteDetailCpt>
              </DetailsContainer>
            </div>
          )}
        </Authorization>
      </VolanteDetail>
      {showRucModal ? (
        ["not_required", "rejected"].includes(thirdPartyStatus.option) ? (
          // <Authorization actions={['billable-ruc.get_billable_rucs']}>
          <AdditionalRucsModalAdmin
            toggleModal={toggleRucModal}
            // updateOtherRucInfo={updateOtherRucInfo}
            closeModalRuc={closeModalRuc}
            showModalTercero={() => {}}
            setShowModalErrorAdditionalRucs={setShowModalErrorAdditionalRucs}
            setShowModalMessageAdditionalRucs={
              setShowModalMessageAdditionalRucs
            }
            updateShowRucModal={updateShowRucModal}
          />
        ) : (
          // </Authorization>
          <AdditionalInfoReviewingModal toggleModal={toggleRucModal} />
        )
      ) : null}
      <Sidebar
        id="vol-aditional-serive-id"
        style={{
          overflowX: "initial",
          width: "70rem",
        }}
        position="right"
        visible={volanteServiceSidebar}
        onHide={() => {
          setVolanteServiceSidebar(false);
        }}
        maskClassName="class-name-sidebar-style-services-additional"
      >
        <VolanteAdditionalServicesAdmin
          dni={dni}
          loadDateWithdrawal={loadDateWithdrawal}
          quotation={quotation}
          onSave={(pricing) => {
            setDeletedItemsByDate([]);
            setPricing(pricing);
          }}
          onOutsideClick={toggleVolanteServiceSidebar}
          additionalServices={additionalServices}
          volante={volante}
          uploadDate={uploadDate}
          dam_num={volante.pricing.dam_num}
        />
      </Sidebar>
    </div>
  );
};
